import {create} from 'zustand';

interface ExtendedTermsState {
    data: { days: number; value: number } | null;
    loading: boolean;
    error: string | null;
    setData: (data: { days: number; value: number }) => void;
    setLoading: (loading: boolean) => void;
    setError: (error: string | null) => void;
    clearData: () => void;
}

const useExtendedTermsStore = create<ExtendedTermsState>((set) => ({
    data: null,
    loading: false,
    error: null,
    setData: (data) => set({ data }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    clearData: () => set({ data: null, loading: false, error: null }),
}));

export default useExtendedTermsStore;